// loader.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest,
  HttpContextToken
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../services/loader.service';


export const SKIP_LOADER = new HttpContextToken(() => false);

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    try {
      let shouldSkip = req.context.get(SKIP_LOADER);

      if (!shouldSkip && req.headers.get('skipLoader') === 'true') {
        shouldSkip = true;
      }

      if (!shouldSkip && req.url.toLowerCase().includes('hasmeetingstarted')) {
        shouldSkip = true;
      }

      if (!shouldSkip && req.url.toLowerCase().includes('getagendagenerationdata')) {
        shouldSkip = true;
      }

      const skipPatterns = ['search', 'dropdown', 'autocomplete', 'lookup', 'list', 'filter'];

      if (!shouldSkip) {
        for (const pattern of skipPatterns) {
          if (req.url.toLowerCase().includes(pattern)) {
            shouldSkip = true;
            break;
          }
        }
      }


      if (!shouldSkip) {
        this.loaderService.show();
      }

      return next.handle(req).pipe(
        finalize(() => {
          if (!shouldSkip) {
            this.loaderService.hide();
          }
        })
      );
    } catch (error) {
      console.error('LoaderInterceptor error:', error);
      console.error('Request URL:', req.url);
      console.error('Request Method:', req.method);
      
      // Ensure loader is hidden if there's an error
      try {
        this.loaderService.hide();
      } catch (loaderError) {
        console.error('Error hiding loader:', loaderError);
      }
      
      // If there's an error, just pass through the request without loader
      return next.handle(req);
    }
  }
}